import { minValue, normalName, required } from '@/validation'

export const createStepValidationRules = {
  name: { required, normalName },
  stepTypeId: { required },
  durationInSeconds: { min: minValue(0) },
}
